var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowBig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 229,
    height: 269,
    viewBox: "0 0 229 269",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M158 1H72C66.4772 1 62 5.47715 62 11V157C62 162.523 66.4772 167 72 167H158C163.523 167 168 162.523 168 157V11C168 5.47715 163.523 1 158 1Z",
    fill: "current",
    stroke: "current",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M107.056 263.702C111.03 268.132 117.97 268.132 121.944 263.702L224.68 149.178C230.456 142.739 225.886 132.5 217.236 132.5H11.7642C3.11423 132.5 -1.45566 142.739 4.32044 149.178L107.056 263.702Z",
    fill: "current",
    stroke: "current",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBig);
export default __webpack_public_path__ + "static/media/arrowBig.eec0cb6e59c4061d78a145b9fd4c16a1.svg";
export { ForwardRef as ReactComponent };